// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js-new/" + ({"130":"store-app","514":"store-user","918":"Account"}[chunkId] || chunkId) + "-" + {"77":"1a973b","130":"999c0f","466":"a38c56","514":"e4eddf","780":"56a39a","918":"347f63"}[chunkId] + ".js";
};